angular.module('aq.admin.accounts.schema').controller('AddCollectorClassModalCtrl',
    function ($scope) {


});